import axios from 'axios'
import config from '../../config'
import router from '../../routes'
import store from '../../store'
import token from '../token'
import { handleCommonResponseErrors } from '../handle-errors'

// create axios instance
const authenticated = axios.create({
  baseURL: `${config.apiDomain}/api`
})

// set access token before request
const preRequest = (config) => {
  const accessToken = store.getters['token/accessToken']
  config.headers = {
    Authorization: `Bearer ${accessToken}`,
    'X-Requested-With': 'XMLHttpRequest'
  }

  return config
}

authenticated.interceptors.request.use(preRequest, (err) => {
  return Promise.reject(err)
})

// handle unauthenticated response
const handle401 = async (err) => {

  // access token is expired
  if (
    err.response &&
    err.response.status === 401
    && err.config &&
    !err.config._isRetryRequest
  ) {

    // clear the expired access token
    store.commit('token/clearAccessToken')

    try {
      const data = {
        'refresh_token': store.getters['token/refreshToken']
      }

      // refresh the token
      const resp = await token.refresh(data)

      // update the store
      store.commit('token/setTokenDataFromAPI', resp.data)
      err.config._isRetryRequest = true

      // retry the previous request
      const accessToken = store.getters['token/accessToken']
      err.config.headers.Authorization = `Bearer ${accessToken}`
      await authenticated(err.config)

    // the refresh token is likely expired
    } catch(err) {

      // clear the expired refresh token
      store.commit('token/clearAccessToken')

      // redirect to login
      router.push({name: 'login'})
    }
  }
}

authenticated.interceptors.response.use(undefined, (err) => {
  handleCommonResponseErrors(err)
  handle401(err)

  return Promise.reject(err)
})

export default authenticated



// WEBPACK FOOTER //
// ./src/api/http-clients/authenticated.js